import type { FaireProductEntity } from "../../entity_types/product";

export const p_wsaxm8rq23: FaireProductEntity = {
  token: "p_wsaxm8rq23",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Chain Necklace - 7002",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/d05b9c739fedc8c9ffc7a22a1750d6b9c2270c72296ebef180b78826973526ad.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e52f7091f1e62f2925abd735839447d47cf8c0b579589d733364d2bd5636bde5.jpeg",
    "https://cdn.faire.com/fastly/ccfc79c5591fe7e9f7aa6aeac6d3bbfe31f6a54d3aab55b62317419be553d46f.jpeg",
    "https://cdn.faire.com/fastly/4cfafbdf0e2a586a97be3081d320b282d86f175e47cde6b8f73475ac889df0f2.jpeg",
    "https://cdn.faire.com/fastly/484537cfd627981a0cdd37edf0c125d428ab0d5d5fab2d2ee5c4a1d2e374efad.jpeg",
  ],
  priceDollars: 10.39,
  description:
    '18K Gold Dipped Stainless Steel Oval Chain Necklace.\nApprox. 18" long including the extender.\n\n\n\n\nThis item is hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the gold plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n\nOval Chain Necklace | Chain Link Necklace | Real Gold Dipped Necklace | Real Gold Plated Necklace | Waterproof & Sweatproof Necklace | Simple Gold Necklace\n',
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:41.728Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
